import * as S from './styles'
import { useMaximumResults } from './useMaximumResults'
import { ReviewContainer } from '../reviews'
import { TextWithHighlighted } from '@/components'
import { Button } from '@/components/button'

export type MaximumResultsProps = {
  handleScrollToElement: () => void
}
export const MaximumResults: React.FC<MaximumResultsProps> = ({
  handleScrollToElement,
}) => {
  const { fontSizes, maximumResultsData } = useMaximumResults()

  return (
    <S.MaximumResultsContainer>
      <TextWithHighlighted
        size={fontSizes.title}
        align="center"
        text={maximumResultsData.title}
      />
      <TextWithHighlighted
        size={fontSizes.subtitle}
        align="center"
        text={maximumResultsData.subtitle}
      />
      <ReviewContainer cards={maximumResultsData.cards} />

      <Button onClick={handleScrollToElement}>
        {maximumResultsData.buttonText}
      </Button>
    </S.MaximumResultsContainer>
  )
}
